import { createActionsHook } from 'src/lib/sweetState';

import { CustomerStore } from './CustomerStore';

export const useCustomerActions = createActionsHook(CustomerStore);
